module.exports = __webpack_public_path__ + "img/carpenter-pool.5e279fee.jpg";